module.exports = __webpack_public_path__ + "static/media/features-immersive-full.30e0f78b.png";